import React, { useState, useEffect, useContext } from 'react';
import { CartContext } from '../context/CartContext';
import { BsShieldFillCheck, BsShieldFillX } from 'react-icons/bs'; // Import des nouvelles icônes

const CartMenuItem = ({ menu, categories }) => {
  const { updateMenuChoice, menuChoices, removeFromCart } = useContext(CartContext);
  const uniqueId = menu.uniqueId;

  if (!uniqueId) {
    console.error('CartMenuItem: uniqueId is undefined for menu', menu);
  }

  const [selectedFormula, setSelectedFormula] = useState(menuChoices[uniqueId]?.selectedFormula || null);
  const [selectedEntrée, setSelectedEntrée] = useState(menuChoices[uniqueId]?.selectedEntrée || null);
  const [selectedPlat, setSelectedPlat] = useState(menuChoices[uniqueId]?.selectedPlat || null);
  const [selectedGarniture, setSelectedGarniture] = useState(menuChoices[uniqueId]?.selectedGarniture || null);
  const [selectedSushi, setSelectedSushi] = useState(menuChoices[uniqueId]?.selectedSushi || null);
  const [selectedMaki, setSelectedMaki] = useState(menuChoices[uniqueId]?.selectedMaki || null);
  const [selectedBoisson, setSelectedBoisson] = useState(menuChoices[uniqueId]?.selectedBoisson || null);
  const [selectedDessert, setSelectedDessert] = useState(menuChoices[uniqueId]?.selectedDessert || null);
  const [isValid, setIsValid] = useState(false);
  const [validationMessage, setValidationMessage] = useState('');

  useEffect(() => {
    if (menu.includes.includes("entrée-plat-dessert")) {
      setSelectedFormula("entrée-plat-dessert");
    }
  }, [menu.includes]);

  useEffect(() => {
    // Validation des choix
    const validateChoices = () => {
      if (!selectedFormula) {
        setValidationMessage("Aucune formule sélectionnée.");
        return false;
      }

      if (selectedFormula.includes("entrée") && !selectedEntrée) {
        setValidationMessage("Une entrée doit être sélectionnée.");
        return false;
      }
      if (selectedFormula.includes("plat") && !selectedPlat) {
        setValidationMessage("Un plat doit être sélectionné.");
        return false;
      }
      if (selectedFormula.includes("garniture") && !selectedGarniture) {
        setValidationMessage("Une garniture doit être sélectionnée.");
        return false;
      }
      if (selectedFormula.includes("dessert") && !selectedDessert) {
        setValidationMessage("Un dessert doit être sélectionné.");
        return false;
      }

      setValidationMessage("Tous les choix requis ont été effectués.");
      return true;
    };

    const isValid = validateChoices();
    setIsValid(isValid);

    updateMenuChoice(uniqueId, {
      selectedFormula,
      selectedEntrée,
      selectedPlat,
      selectedGarniture,
      selectedDessert,
      isValid,
    });
  }, [
    selectedFormula,
    selectedEntrée,
    selectedPlat,
    selectedGarniture,
    selectedDessert,
    uniqueId,
  ]);

  const handleSelect = (type, item) => {
    if (type === 'entrées') setSelectedEntrée(item);
    if (type === 'plats') setSelectedPlat(item);
    if (type === 'garnitures') setSelectedGarniture(item);
    if (type === 'sushis') setSelectedSushi(item);
    if (type === 'maki') setSelectedMaki(item);
    if (type === 'boissons') setSelectedBoisson(item);
    if (type === 'desserts') setSelectedDessert(item);

    const updatedChoice = {
      selectedFormula,
      selectedEntrée: type === 'entrées' ? item : selectedEntrée,
      selectedPlat: type === 'plats' ? item : selectedPlat,
      selectedGarniture: type === 'garnitures' ? item : selectedGarniture,
      selectedSushi: type === 'sushis' ? item : selectedSushi,
      selectedMaki: type === 'maki' ? item : selectedMaki,
      selectedBoisson: type === 'boissons' ? item : selectedBoisson,
      selectedDessert: type === 'desserts' ? item : selectedDessert,
    };

    updateMenuChoice(uniqueId, updatedChoice);
  };

  const handleFormulaSelect = (formula) => {
    setSelectedFormula(formula);
    setSelectedEntrée(null);
    setSelectedPlat(null);
    setSelectedGarniture(null);
    setSelectedSushi(null);
    setSelectedMaki(null);
    setSelectedBoisson(null);
    setSelectedDessert(null);

    const updatedChoice = {
      selectedFormula: formula,
      selectedEntrée: null,
      selectedPlat: null,
      selectedGarniture: null,
      selectedSushi: null,
      selectedMaki: null,
      selectedBoisson: null,
      selectedDessert: null,
    };

    updateMenuChoice(uniqueId, updatedChoice);
  };

  const isDisabled = (type) => {
    if (!selectedFormula) return false;
    return !selectedFormula.includes(type);
  };

  return (
    <li className="cart-menu-item">
      <div className='infos-base-menu'>
        <button className="del-button" onClick={() => removeFromCart(menu)}>×</button>
        <h2>{menu.nom}</h2>
        <p className='price'>{menu.prix} €</p>
        <span className="validation-icon">
          {isValid ? (
            <BsShieldFillCheck className="status-icon complete" title="Tous les choix sont validés" />
          ) : (
            <BsShieldFillX className="status-icon incomplete" title="Des choix sont manquants" />
          )}
        </span>
      </div>
     
      {!menu.includes.includes("entrée-plat-garniture-dessert") && (
        <div>
          <h3>Choisissez une formule</h3>
          <ul>
            {menu.includes.map(include => (
              <li
                key={include}
                onClick={() => handleFormulaSelect(include)}
                className={selectedFormula === include ? 'selected' : ''}
              >
                {include.replace(/-/g, ' et ')}
              </li>
            ))}
          </ul>
        </div>
      )}
      {menu.options.entrées && (
        <div>
          <h3>Choisissez une entrée</h3>
          <ul>
            {menu.options.entrées.map(id => {
              const item = categories.entrées.find(item => item.id === id);
              return item ? (
                <li
                  key={id}
                  onClick={() => handleSelect('entrées', item)}
                  className={selectedEntrée && selectedEntrée.id === id ? 'selected' : ''}
                  style={{ pointerEvents: isDisabled('entrée') ? 'none' : 'auto', opacity: isDisabled('entrée') ? 0.5 : 1 }}
                >
                  {item.nom}
                </li>
              ) : null;
            })}
          </ul>
        </div>
      )}
      {menu.options.plats && (
        <div>
          <h3>Choisissez un plat</h3>
          <ul>
            {menu.options.plats.map(id => {
              const item = categories.plats.find(item => item.id === id);
              return item ? (
                <li
                  key={id}
                  onClick={() => handleSelect('plats', item)}
                  className={selectedPlat && selectedPlat.id === id ? 'selected' : ''}
                  style={{ pointerEvents: isDisabled('plat') ? 'none' : 'auto', opacity: isDisabled('plat') ? 0.5 : 1 }}
                >
                  {item.nom}
                </li>
              ) : null;
            })}
          </ul>
        </div>
      )}
      {menu.options.garnitures && (
        <div>
          <h3>Choisissez une garniture</h3>
          <ul>
            {menu.options.garnitures.map(id => {
              const item = categories.garniture.find(item => item.id === id);
              return item ? (
                <li
                  key={id}
                  onClick={() => handleSelect('garnitures', item)}
                  className={selectedGarniture && selectedGarniture.id === id ? 'selected' : ''}
                  style={{ pointerEvents: isDisabled('garniture') ? 'none' : 'auto', opacity: isDisabled('garniture') ? 0.5 : 1 }}
                >
                  {item.nom}
                </li>
              ) : null;
            })}
          </ul>
        </div>
      )}
      {menu.options.sushis && (
        <div>
          <h3>Choisissez un sushi</h3>
          <ul>
            {menu.options.sushis.map(id => {
              const item = categories.sushis.find(item => item.id === id);
              return item ? (
                <li
                  key={id}
                  onClick={() => handleSelect('sushis', item)}
                  className={selectedSushi && selectedSushi.id === id ? 'selected' : ''}
                  style={{ pointerEvents: isDisabled('sushi') ? 'none' : 'auto', opacity: isDisabled('sushi') ? 0.5 : 1 }}
                >
                  {item.nom}
                </li>
              ) : null;
            })}
          </ul>
        </div>
      )}
      {menu.options.maki && (
        <div>
          <h3>Choisissez un maki</h3>
          <ul>
            {menu.options.maki.map(id => {
              const item = categories.maki.find(item => item.id === id);
              return item ? (
                <li
                  key={id}
                  onClick={() => handleSelect('maki', item)}
                  className={selectedMaki && selectedMaki.id === id ? 'selected' : ''}
                  style={{ pointerEvents: isDisabled('maki') ? 'none' : 'auto', opacity: isDisabled('maki') ? 0.5 : 1 }}
                >
                  {item.nom}
                </li>
              ) : null;
            })}
          </ul>
        </div>
      )}
      {menu.options.boissons && (
        <div>
          <h3>Choisissez une boisson</h3>
          <ul>
            {menu.options.boissons.map(id => {
              const item = categories.boisson.find(item => item.id === id);
              return item ? (
                <li
                  key={id}
                  onClick={() => handleSelect('boissons', item)}
                  className={selectedBoisson && selectedBoisson.id === id ? 'selected' : ''}
                  style={{ pointerEvents: isDisabled('boisson') ? 'none' : 'auto', opacity: isDisabled('boisson') ? 0.5 : 1 }}
                >
                  {item.nom}
                </li>
              ) : null;
            })}
          </ul>
        </div>
      )}
      {menu.options.desserts && (
        <div>
          <h3>Choisissez un dessert</h3>
          <ul>
            {menu.options.desserts.map(id => {
              const item = categories.desserts.find(item => item.id === id);
              return item ? (
                <li
                  key={id}
                  onClick={() => handleSelect('desserts', item)}
                  className={selectedDessert && selectedDessert.id === id ? 'selected' : ''}
                  style={{ pointerEvents: isDisabled('dessert') ? 'none' : 'auto', opacity: isDisabled('dessert') ? 0.5 : 1 }}
                >
                  {item.nom}
                </li>
              ) : null;
            })}
          </ul>
        </div>
      )}
      <div className="validation-message">
        <p className='etatMenu'>{validationMessage}</p>
      </div>
    </li>
  );
};

export default CartMenuItem;
